import { ArtistType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { ArtistContactsTableRow } from './components';
import { artistContactRows } from './data';

type ArtistContactsTablePropsType = {
  artist: ArtistType;
};

export const ArtistContactsTable: React.FC<ArtistContactsTablePropsType> = ({
  artist,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {artistContactRows.map((row) => (
          <ArtistContactsTableRow key={row.accessor} artist={artist} row={row} />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
